module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Loglist,
      "border": "",
      "max-height": "680"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间",
      "width": "170",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "内容"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a18fc6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Log.vue
// module id = 1266
// module chunks = 1